"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailEditorConfig = void 0;
const emaileditor_1 = require("./emaileditor");
Object.defineProperty(exports, "EmailEditorConfig", { enumerable: true, get: function () { return emaileditor_1.EmailEditorConfig; } });
